import React, { FC } from 'react';
import { BoxProps } from 'types';
import * as S from './styles';

export const Box: FC<BoxProps> = ({ children, ...props }) => {
	return <S.Box {...props}>{children}</S.Box>;
};

Box.defaultProps = { testId: 'box' };

export default Box;
